module.exports = __webpack_public_path__ + "img/complete_check.b04e12b5.svg";